import React from 'react';
import { motion } from 'framer-motion';
export function RoadmapSection() {
  const weeks = [{
    num: 1,
    title: 'CLARIDAD',
    desc: 'Diagnóstico + orden mínimo. Sabés dónde estás parado/a y qué atacar primero.'
  }, {
    num: 2,
    title: 'LIMPIEZA',
    desc: 'Cierre de fugas del hogar. Limpieza física y simbólica. Primer alivio real.'
  }, {
    num: 3,
    title: 'BLINDAJE',
    desc: 'Protección del espacio + límites + convivencia sin conflicto.'
  }, {
    num: 4,
    title: 'FINANZAS',
    desc: 'Detección de fugas de dinero + administración simple + mentalidad de flujo.'
  }, {
    num: 5,
    title: 'SALUD',
    desc: 'Protocolo de sueño + manejo de ansiedad + recuperación de energía.'
  }, {
    num: 6,
    title: 'SOSTENIMIENTO',
    desc: 'Automatización de hábitos + plan anti-retroceso + consolidación de la victoria.'
  }];
  return <section className="py-12 md:py-32 px-4 bg-secondary-bg relative" data-id="element-334">
      <div className="max-w-3xl mx-auto" data-id="element-335">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-8 md:mb-16" data-id="element-336">
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-337">
            Tu Plan de 6 Semanas
          </h2>
          <p className="text-text-secondary font-body-serif text-base md:text-xl" data-id="element-338">
            Cada semana tiene un foco claro. Si te atrasás, seguís desde donde
            estés.
          </p>
        </motion.div>

        <div className="bg-card-bg rounded-2xl md:rounded-3xl p-4 md:p-10 border border-border-gold shadow-md relative overflow-hidden" data-id="element-339">
          <div className="relative" data-id="element-340">
            <div className="absolute left-[13px] md:left-[15px] top-4 bottom-4 w-px bg-gold/30" data-id="element-341" />

            <div className="space-y-5 md:space-y-8" data-id="element-342">
              {weeks.map(week => <div key={week.num} className="relative pl-10 md:pl-12" data-id="element-343">
                  <div className="absolute left-0 top-0.5 w-7 h-7 md:w-8 md:h-8 rounded-full bg-card-bg border-2 border-gold flex items-center justify-center shadow-sm" data-id="element-344">
                    <span className="text-gold text-[10px] md:text-xs font-bold" data-id="element-345">
                      {week.num}
                    </span>
                  </div>
                  <div data-id="element-346">
                    <h3 className="font-bold text-sm md:text-lg text-text-primary mb-0.5" data-id="element-347">
                      Semana {week.num} —{' '}
                      <span className="text-gold" data-id="element-348">{week.title}</span>
                    </h3>
                    <p className="text-text-secondary text-xs md:text-base font-medium" data-id="element-349">
                      {week.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="mt-6 md:mt-10 pt-4 md:pt-6 border-t border-border-gold text-center" data-id="element-350">
            <p className="text-xs md:text-sm text-text-muted italic" data-id="element-351">
              ⏱ Si te atrasás, no pasa nada. El sistema está diseñado para que
              retomes, no para que reinicies.
            </p>
          </div>
        </div>
      </div>
    </section>;
}